import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionLevel } from './competition-level'
import { competitionLevelActions } from './competition-level.actions'
import * as fromCompetitionLevel from './competition-level.reducer'
import { CompetitionLevelService } from './competition-level.service'

@Injectable()
export class CompetitionLevelEffects extends ResourceEffects<CompetitionLevel> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionLevelService: CompetitionLevelService
  ) {
    super(
      fromCompetitionLevel.FEATURE_NAME,
      competitionLevelService,
      competitionLevelActions,
      actions$
    )
  }
}
